/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TrecUtilsModule } from "@trec/api/utils";
import { C3CopyClipboardBtnModule } from "@trec/components/copy-clipboard-btn";
import { C3GetIconModule } from "@trec/components/get-icon";
import { C3TooltipModule } from "@trec/components/tooltip";
import { AppActivationCodeDialogComponent } from "./components/app-activation-code-dialog/app-activation-code-dialog.component";
import { AppActivationCodeViewComponent } from "./components/app-activation-code-view/app-activation-code-view.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,

    IonicModule,

    C3GetIconModule,
    C3TooltipModule,
    C3CopyClipboardBtnModule,

    TrecUtilsModule,
  ],
  declarations: [AppActivationCodeViewComponent, AppActivationCodeDialogComponent],
  exports: [AppActivationCodeViewComponent, AppActivationCodeDialogComponent],
})
export class AppPrescrSharedModule {}
